import { render } from "./ComplexTable.vue?vue&type=template&id=350a2ee0"
import script from "./ComplexTable.vue?vue&type=script&lang=ts"
export * from "./ComplexTable.vue?vue&type=script&lang=ts"
script.render = render

export default script